import * as React from 'react';
import CertificationCore from '../AfrCore/CertificationCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const CertificationA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <CertificationCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default CertificationA;